import format from 'date-fns/format';
import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Grid, Header, Segment, Table } from 'semantic-ui-react';
import ReadAxiosc from '../axiosComponent/commonRead';
import AgGridTable from '../common/agGridTable'
function InTransitVehicle() {
    const [start, setStart] = useState('')
    const [end, setEnd] = useState('')
    const [isLoading, setisLoading] = useState(false)
    const [data, setdata] = useState([])
    const endDateHandle = (e) => {
        setEnd(e)
    }
    const handleSubmit = () => {
        ReadAxiosc({
            completeURL: `${process.env.REACT_APP_BASE_COMMON}/dispatch/inTransitVehicleReport?fromDate=${format(start, 'yyyy-MM-dd')}&toDate=${format(end, 'yyyy-MM-dd')}`,
        }).then((response) => {
            // console.log(response)
            setdata(response.data.resultSet)
        })
    }
    const startDateHandle = (e) => {
        setStart(e)
    }

    let columnDefs = [
        { headerName: 'Vertical', field: 'vertical', tooltipField: 'vertical', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Market', field: 'market', tooltipField: 'market', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Owned', field: 'owned', tooltipField: 'owned', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Total In-Transit Vehicle', field: 'totalInTransitVehicle', tooltipField: 'totalInTransitVehicle', enableRowGroup: true, enablePivot: true, filter: true },
    ]
    return (
        <>
            <AgGridTable
                masters={false}
                loading={isLoading}
                columnDefs={columnDefs}
                rowData={data}
                pagination={false}
                titleBarTitle="In-Transit Vehicles"
                paginationPageSize={10}
                reportsFilter={
                    <>
                        <div className="container-fluid  text-center p-2 w3-white">
                            <div className="row">
                                <div className="col-md-1 mt-1">
                                    <label>Date</label>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex" style={{ flex: 1 }}>
                                        <div>
                                            <DatePicker
                                                selected={start}
                                                onChange={startDateHandle}
                                                dateFormat="dd/MM/yyyy"
                                                selectsStart
                                                startDate={start}
                                                endDate={end}
                                                showMonthDropdown
                                                placeholderText="Start Date"
                                                className="form-control"
                                            />
                                        </div>
                                                &nbsp;~&nbsp;
                                                <div>
                                            <DatePicker
                                                selected={end}
                                                onChange={endDateHandle}
                                                startDate={start}
                                                endDate={end}
                                                showMonthDropdown
                                                minDate={start}
                                                selectsEnd
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <button type="button" onClick={handleSubmit} disabled={start && end ? false : true} className="w3-button w3-small w3-blue w3-hover-blue w3-round">Apply</button>
                                </div>
                            </div>
                        </div>
                    </>}
            />
        </>
    )
}

export default InTransitVehicle
